import { render, staticRenderFns } from "./carList.vue?vue&type=template&id=4c48fc84&scoped=true"
import script from "./carList.vue?vue&type=script&lang=ts"
export * from "./carList.vue?vue&type=script&lang=ts"
import style0 from "./carList.vue?vue&type=style&index=0&id=4c48fc84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c48fc84",
  null
  
)

export default component.exports